import React, { useContext } from 'react'

import { BreakConfigurationFragment } from 'generated/resources/graphql'

import { AttendanceBreakConfigurations } from 'modules/attendance/hooks/useGetAttendanceBreakConfigurationsRange'

interface ContextProps {
  allBreaks: BreakConfigurationFragment[]
  attendanceBreaks: Map<string, AttendanceBreakConfigurations[]> | undefined
  todayBreaks: AttendanceBreakConfigurations[]
  clockinAttendanceBreaks?: AttendanceBreakConfigurations[]
  loadingBreaks: boolean
}

const AttendanceBreaksContext = React.createContext<ContextProps | null | undefined>(null)

export const AttendanceBreaksProvider = ({
  value,
  children,
}: {
  value: ContextProps
  children: React.ReactNode
}) => <AttendanceBreaksContext.Provider value={value}>{children}</AttendanceBreaksContext.Provider>

export const useAttendanceBreaks = () => {
  const attendanceBreaks = useContext(AttendanceBreaksContext)

  if (!attendanceBreaks) {
    throw new Error('useAttendanceBreaks must be used within a Provider')
  }

  return attendanceBreaks
}
